import React from 'react';
import { Play, Trash, Download, Pencil } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import api from '../api'; // Import de l'instance api

const MovieCard = ({ movie, onDelete, onEdit }) => {
    const navigate = useNavigate();
    const token = localStorage.getItem('token');
    
    // On récupère l'URL de base dynamiquement depuis l'instance api
    const baseURL = api.defaults.baseURL.replace(/\/api$/, ''); 
    const downloadUrl = `${baseURL}/api/download/${movie.id}?token=${token}`;

    return (
        <div className="movie-poster-card" onClick={() => navigate(`/watch/${movie.id}`)}>
            <div className="poster-info">
                <p className="poster-title">{movie.title}</p>
                <div className="d-flex justify-content-between align-items-center">
                    <span className="poster-year">
                        {movie.release_year} • {movie.genre}
                    </span>

                    <div className="d-flex gap-2 align-items-center">
                        <a href={downloadUrl} 
                           className="text-muted hover-white" 
                           onClick={(e) => e.stopPropagation()}
                           title="Télécharger"
                        >
                            <Download size={14} />
                        </a>

                        <span 
                            onClick={(e) => { e.stopPropagation(); onEdit(movie); }} 
                            className="text-primary opacity-50 hover-opacity-100"
                            style={{ cursor: 'pointer' }}
                            title="Modifier"
                        >
                            <Pencil size={14} />
                        </span>

                        <span 
                            onClick={(e) => { e.stopPropagation(); onDelete(movie.id); }} 
                            className="text-danger opacity-50 hover-opacity-100"
                            style={{ cursor: 'pointer' }}
                            title="Supprimer"
                        >
                            <Trash size={14} />
                        </span>
                    </div>
                </div>
            </div>
            
            <div className="play-hint">
                <Play size={18} fill="currentColor" />
            </div>
        </div>
    );
};

export default MovieCard;